(function () {
    const PARAM = 'kategorie';
    const PAGE_PARAM = 'seite';
    const controllers = new WeakMap();

    // "Alle Beiträge" hat keinen (oder einen leeren) data-kategorie-Wert
    function lhm_getLinkSlug(link) {
        return link.dataset.kategorie || '';
    }

    function lhm_getBlogFilterLinks(section) {
        return Array.from(section.querySelectorAll('.uebersichtFilterLink'));
    }

    function lhm_setActiveBlogFilter(section, slug) {
        lhm_getBlogFilterLinks(section).forEach((link) => {
            if (lhm_getLinkSlug(link) === slug) {
                link.setAttribute('aria-current', 'true');
            } else {
                link.removeAttribute('aria-current');
            }
        });
    }

    function lhm_getActiveBlogFilter(section) {
        const active = section.querySelector('.uebersichtFilterLink[aria-current="true"]');
        return active ? lhm_getLinkSlug(active) : '';
    }

    // Ohne Pagination (nur eine Seite) gilt Seite 1
    function lhm_getActiveBlogPage(section) {
        const active = section.querySelector('.uebersichtPaginationLink[aria-current="page"]');
        return active ? parseInt(active.dataset.seite, 10) : 1;
    }

    function lhm_updateBlogUrl(slug, page) {
        const url = new URL(window.location.href);

        if (slug) {
            url.searchParams.set(PARAM, slug);
        } else {
            url.searchParams.delete(PARAM);
        }

        if (page > 1) {
            url.searchParams.set(PAGE_PARAM, page);
        } else {
            url.searchParams.delete(PAGE_PARAM);
        }

        window.history.pushState({ [PARAM]: slug, [PAGE_PARAM]: page }, '', url);
    }

    // Nach dem Seitenwechsel an den Anfang der Ergebnisse springen und den Fokus
    // dorthin setzen, sonst bleiben Tastatur-/Screenreader-Nutzer unten an der Pagination
    function lhm_focusBlogResults(section, results) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        results.focus({ preventScroll: true });
        section.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }

    function lhm_loadBlogPosts(section, slug, page, focusResults) {
        const results = section.querySelector('.uebersichtResults');

        if (!results) {
            return;
        }

        const previous = controllers.get(section);
        if (previous) {
            previous.abort();
        }

        const controller = new AbortController();
        controllers.set(section, controller);

        const body = new FormData();
        // Blog- und Eventübersicht teilen sich die Action (lhm_ajaxUebersichtFilter)
        body.append('action', section.dataset.action || 'lhm_uebersicht_filter');
        body.append('post_id', section.dataset.postId);
        body.append('row', section.dataset.row);
        body.append('lang', section.dataset.lang || '');
        body.append(PARAM, slug);
        body.append(PAGE_PARAM, page);

        lhm_setActiveBlogFilter(section, slug);
        section.classList.add('is-loading');
        results.setAttribute('aria-busy', 'true');

        fetch(section.dataset.ajaxUrl, {
            method: 'POST',
            body: body,
            credentials: 'same-origin',
            signal: controller.signal,
        })
            .then((response) => response.json())
            .then((json) => {
                if (!json.success) {
                    throw new Error(json.data || 'Blogfilter fehlgeschlagen');
                }

                results.innerHTML = json.data.html;

                if (focusResults) {
                    lhm_focusBlogResults(section, results);
                }
            })
            .catch((error) => {
                if (error.name === 'AbortError') {
                    return;
                }

                results.innerHTML = '<p class="uebersichtLeer">' + (section.dataset.errorText || '') + '</p>';
            })
            .finally(() => {
                if (controllers.get(section) === controller) {
                    controllers.delete(section);
                    section.classList.remove('is-loading');
                    results.removeAttribute('aria-busy');
                }
            });
    }

    function lhm_getSlugFromUrl(section) {
        const slug = new URL(window.location.href).searchParams.get(PARAM) || '';
        const exists = lhm_getBlogFilterLinks(section).some((link) => lhm_getLinkSlug(link) === slug);

        return exists ? slug : '';
    }

    function lhm_getPageFromUrl() {
        const page = parseInt(new URL(window.location.href).searchParams.get(PAGE_PARAM), 10);
        return page > 1 ? page : 1;
    }

    function lhm_isModifiedClick(e) {
        return e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
    }

    document.addEventListener('DOMContentLoaded', function () {
        const sections = Array.from(document.querySelectorAll('.layoutUebersicht[data-ajax-url]'));

        if (!sections.length) {
            return;
        }

        sections.forEach((section) => {
            section.addEventListener('click', function (e) {
                const filterLink = e.target.closest('.uebersichtFilterLink');
                const pageLink = e.target.closest('.uebersichtPaginationLink');

                // Modifier-Klicks (neuer Tab etc.) dem Browser überlassen
                if ((!filterLink && !pageLink) || lhm_isModifiedClick(e)) {
                    return;
                }

                e.preventDefault();

                if (filterLink) {
                    // Kategoriewechsel startet immer auf Seite 1
                    const slug = lhm_getLinkSlug(filterLink);
                    if (slug === lhm_getActiveBlogFilter(section)) {
                        return;
                    }

                    lhm_updateBlogUrl(slug, 1);
                    lhm_loadBlogPosts(section, slug, 1, false);
                    return;
                }

                const page = parseInt(pageLink.dataset.seite, 10);
                if (page === lhm_getActiveBlogPage(section)) {
                    return;
                }

                const slug = lhm_getActiveBlogFilter(section);
                lhm_updateBlogUrl(slug, page);
                lhm_loadBlogPosts(section, slug, page, true);
            });
        });

        window.addEventListener('popstate', function () {
            sections.forEach((section) => {
                const slug = lhm_getSlugFromUrl(section);
                const page = lhm_getPageFromUrl();

                if (slug !== lhm_getActiveBlogFilter(section) || page !== lhm_getActiveBlogPage(section)) {
                    lhm_loadBlogPosts(section, slug, page, false);
                }
            });
        });
    });
})();
